import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        All rights powered by Perukkal 100 Consultancy Pvt Ltd CIN -
        U66190TZ2024PTC031218
      </p>
    </footer>
  );
};

export default Footer;
